/**
 * Generates a UUID v4 string
 * Uses crypto.randomUUID if available, otherwise falls back to a polyfill
 */
export function generateUUID(): string {
  // Use native crypto.randomUUID if available
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  // Fallback polyfill for environments without crypto.randomUUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Generates a random numeric paxId for PAN card tracking
 * Returns a 16-digit number string (e.g., "1035836674835301")
 */
export function generatePaxId(): string {
  // Generate a 16-digit random number
  const timestamp = Date.now(); // 13 digits
  const random = Math.floor(Math.random() * 1000); // 3 digits
  return `${timestamp}${random.toString().padStart(3, '0')}`;
}
